import { render, staticRenderFns } from "./EditLoyerDialog.vue?vue&type=template&id=6a5a8b0a&"
import script from "./EditLoyerDialog.vue?vue&type=script&lang=ts&"
export * from "./EditLoyerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports